#import "../fragments/order.fragment.graphql"

query getLastOrder($eth_address: String, $market_id: String, $order_type: String, $status: String) {
    getLastOrder(eth_address: $eth_address, market_id: $market_id, order_type: $order_type, status: $status) {
        ...OrderFragment
    }
}
